<script>
import { mapState } from 'vuex';

export default {
  data: () => ({
    name: '',
    email: '',
    message: '',
  }),

  computed: {
    ...mapState('auth', ['authUser']),

    validationError() {
      if (!this.name) return 'Please enter your Name';
      // if (!this.email) return 'Please enter an Email for us to get back'; Do not make email required
      if (!this.message || !this.message.trim()) return 'Please enter a message';

      return undefined;
    },
  },

  mounted() {
    this.name = this.authUser.full_name;
    this.email = this.authUser.email;
  },

  methods: {
    clearForm() {
      this.name = this.authUser.full_name;
      this.email = this.authUser.email;
      this.message = '';
    },
  },
}
</script>

<template>
  <b-card>
    <h4 class="text-center text-success mb-5">
      <i class="fa fa-smile-o"></i>
      Give us some Feedback
    </h4>

    <api-form
      method="post"
      url="v1/UserFeedback"
      submit-text="Send"
      :validation-error="validationError"
      :payload="{name: name, email: email, message: message}"
      :make-success-message="() => 'Thank you for your feedback'"
      @success="clearForm();"
      @cancel="$emit('cancel')">

      <b-form-group label="Name" :label-for="`name-${_uid}`">
        <b-form-input :id="`name-${_uid}`" v-model="name" type="text" placeholder="Name..." required @focus="$event.target.select()"></b-form-input>
      </b-form-group>

      <b-form-group label="Email" :label-for="`email-${_uid}`">
        <b-form-input :id="`email-${_uid}`" v-model="email" type="text" placeholder="Email..." @focus="$event.target.select()"></b-form-input>
      </b-form-group>

      <b-form-group label="Message" :label-for="`message-${_uid}`">
        <b-form-textarea :id="`message-${_uid}`" v-model="message" :rows="6" :max-rows="20" placeholder="Tell us what you think..." required @focus="$event.target.select()"></b-form-textarea>
      </b-form-group>

      <div class="mt-5"></div>

    </api-form>
  </b-card>
</template>



// WEBPACK FOOTER //
// src/feedback/components/FeedbackForm.vue